import * as React from 'react';
import classnames from 'classnames';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import './Card.css';

export interface Props extends FlexProps {
  /**
   * Used when CardContent should be divided. Don't forget to add
   * the CardDividers ;)
   */
  direction?: 'horizontal' | 'vertical';
}

/**
 * Presentation component for lifting and group content on a page. Also
 * great for chunky lists.
 */
const Card: React.FunctionComponent<Props> = (props: Props) => {
  const { direction, borderRadius = 'x2', ...rest } = props;
  const classes = classnames('Card', {
    [`Card--direction-${direction}`]: direction,
  });

  return (
    <Flex { ...rest }
        borderRadius={ borderRadius }
        className={ classes }
        direction={ direction } />
  );
};

export default Card;
